import {Tag as PeacockTag} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').ITagProps} TagProps
 * @property {'default' | 'gray' | 'green' | 'red' | 'orange' | 'blue' | 'purple'} [color] Tag color.
 * @property {string | import('react').ReactNode} [text] Tag label content.
 * @property {boolean} [isRemovable] Whether the tag can be removed.
 * @property {boolean} [isCopyable] Whether the tag can be copied.
 * @property {'large' | 'small'} [size] Tag size.
 * @property {import('react').MouseEventHandler<HTMLSpanElement>} [onRemove] Handler for remove action.
 * @property {'default' | 'faded' | 'outlined'} [type] Tag visual type.
 * @property {string | import('react').SVGProps<SVGSVGElement>} [iconLeading] Optional leading icon.
 * @property {(e: import('react').MouseEvent<HTMLSpanElement>) => void} [onClick] Click handler.
 * @property {boolean} [disabled] Whether tag is disabled.
 * @property {boolean} [skeleton] Renders skeleton state.
 * @property {import('@pepsico-ds/ui').IBaseButtonProps} [removableButtonProps] Props for internal removable button.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS Tag.
 * Supports all Peacock DS tag props.
 * @param {TagProps} props
 */
export const Tag = ({isCopyable = false, ...restProps}) => {
  return <PeacockTag isCopyable={isCopyable} {...restProps} />
}
